<template>
  <vs-row v-if="templates && templates.length">
    <vs-col type="flex" vs-w="4" vs-xs="12" style="margin-bottom: 20px;" :key="indexData" v-for="(data, indexData) in templates">
      <vs-card class="cardx">
        <div slot="header">
          <vs-row>
            <vs-col vs-w="6" class="text-left">
              <vs-icon icon="mail" size="small" color="#a7abc3" class="align-middle mr-2"></vs-icon>
              <span class="align-middle">{{ data.title }}</span>
            </vs-col>
            <vs-col vs-w="6" class="text-right">
              <vs-row vs-justify="flex-end">
                <badge-sms-type :content="$stringHelper.getContentLength(data.content.trim()) <= 90 ? 1 : 2"></badge-sms-type>&nbsp;
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="small"
                  @click.prevent="editTemplate(data)" v-if="editTemplate">
                </vs-button>&nbsp;
                <vs-button
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  @click.prevent="deleteTemplate(data.id)" v-if="deleteTemplate">
                </vs-button>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <div>
          <vs-textarea readonly v-model="data.content" height="170px" class="resize: none;" @click="$emit('selectTemplate', data.content.trim())"/>
        </div>
        <div>
          <vs-row>
            <vs-col vs-w="6" class="text-left">
              <span v-if="displayCategoryLabel===true">{{ $t('category') }} : </span>{{ data.category_title }}
            </vs-col>
            <vs-col vs-w="6" class="text-right">
              <span class="pull-right">Bytes : {{ $stringHelper.getContentLength(data.content.trim()) }}</span>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import BadgeSmsType  from '@/components/badge/SmsType'

export default {
  name: 'Shared.Messages.Templates.List',
  components: {
    BadgeSmsType
  },
  props: {
    templates: {
      type: [Object, Array],
      required: true
    },
    editTemplate: {
      type: Function
    },
    updateTemplate: {
      type: Function
    },
    deleteTemplate: {
      type: Function
    },
    displayCategoryLabel: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style scoped>
.cardx {
    width: calc(100% - 15px);
    margin: 10px;
}
</style>
